import { render } from "./AccountSelect.vue?vue&type=template&id=7b0994c7"
import script from "./AccountSelect.vue?vue&type=script&lang=js"
export * from "./AccountSelect.vue?vue&type=script&lang=js"

import exportComponent from "/home/ploi/pakair.com.au/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__